import "./Settings.css";

import { useEffect, useRef, useState } from "react";

import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { useAuthHeader } from "react-auth-kit";

function ProfileSettings() {
  const authHeader = useAuthHeader();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ severity: "", message: "" });

  const fullNameRef = useRef(null);
  const emailRef = useRef(null);

  const setInputs = () => {
    setFullName(fullNameRef.current.value);
    setEmail(emailRef.current.value);
  }

  // Load the user's profile data on page load
  useEffect(() => {
    const url = `${process.env.REACT_APP_BASE_URL}/user/me`;
    const config = {
      headers: {
        "accept": "application/json",
        "Authorization": authHeader()
      },
    };

    axios.get(url, config)
      .then(response => {
        fullNameRef.current.value = response.data.full_name;
        emailRef.current.value = response.data.email;
        setInputs();
      })
      .catch(error => {
        if (error.response) {
          setAlert({ severity: "error", message: error.response.data.detail });
        } else {
          setAlert({ severity: "error", message: "Unable to connect to server" });
        }

        // Set alert back to empty after 10 seconds
        setTimeout(() => {
          setAlert({ severity: "", message: "" });
        }, 10000);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    const searchParams = new URLSearchParams({
      full_name: fullName,
    });

    const url = `${process.env.REACT_APP_BASE_URL}/user/update_profile?${searchParams.toString()}`;
    const data = {};
    const config = {
      headers: {
        "accept": "application/json",
        "Authorization": authHeader()
      },
    };

    axios.post(url, data, config)
      .then(response => {
        setAlert({ severity: "success", message: response.data.message });
        // Set alert back to empty after 10 seconds
        setTimeout(() => {
          setAlert({ severity: "", message: "" });
        }, 10000);
      })
      .catch(error => {
        if (error.response) {
          setAlert({ severity: "error", message: error.response.data.detail });
        } else {
          setAlert({ severity: "error", message: "Unable to connect to server" });
        }

        // Set alert back to empty after 10 seconds
        setTimeout(() => {
          setAlert({ severity: "", message: "" });
        }, 10000);
      });
  };

  return (
    <div className="profile-settings-container">
      <Stack sx={{ width: '100%' }} spacing={2}>
        {alert.severity !== '' ? (
          <Alert severity={alert.severity}>{alert.message}</Alert>
        ) : null}
      </Stack>
      <h1 className="profile-settings-header">Edit Profile</h1>
      <form className="profile-settings-form-edit-profile" onSubmit={handleSubmit}>
        <label className="profile-settings-form-label">Full Name</label>
        <input className="profile-settings-form-input" type="text" ref={fullNameRef} onChange={setInputs} />

        <label className="profile-settings-form-label">Email</label>
        <input className="profile-settings-form-input" type="email" readOnly ref={emailRef} onChange={setInputs} />

        <button className="profile-settings-form-submit-button" type="submit">Update Profile</button>
      </form>
    </div>
  );
}

export default ProfileSettings;